export const APP_CONFIG = {
  debug: true,
  viewh5p:process.env.VUE_APP_VIEW_H5P,
  domain:process.env.VUE_APP_DOMAIN,
  appUrl: process.env.VUE_APP_ROOT_API,
  apiRootUrl: process.env.VUE_APP_ROOT_API,
  apiUrl: process.env.VUE_APP_API_URL,
  cdnUrl: process.env.VUE_APP_CDN_URL,
  dataUrl: process.env.VUE_APP_DATA_URL,
  uploadUrl: process.env.VUE_APP_UPLOAD_URL,
  searchApiUrl: process.env.VUE_APP_SEARCH_API_URL,
  signalRUrl: process.env.VUE_APP_SIGNALR_URL,
  bookCdnUrl: process.env.VUE_APP_BOOK_CDN_URL,
  bookImgCdnUrl: process.env.VUE_APP_BOOK_IMAGE_CDN_URL,
  urlQuestionImg: process.env.VUE_APP_URL_QUESTION_IMG,
  urlQuestionImgDev: process.env.VUE_APP_URL_QUESTION_IMG_DEV,
  urlCmsImg: process.env.VUE_APP_URL_IMG_CMS,
  urlPlatformCmsImg: process.env.VUE_APP_URL_IMG_PLATFORM_CMS,
  cdnLive: process.env.VUE_APP_URL_CDN_LIVE,
  cmsLinkImg: process.env.VUE_APP_URL_CMS_IMG,
};